export interface Field {
	override: unknown;
}

export enum MatterFormsSource {
	GLOBAL = 'global',
	LOCAL = 'local',
}

export interface MatterFormsV2 {
	id: string;
	formType?: string;
	formTypeVersion?: string;
	sourceId: string;
	source: MatterFormsSource;
	originalSource: MatterFormsSource;
	fields: { [key: string]: Field };
	url?: string;
	barcodeUrl?: string;
}
